import React, { useRef } from 'react';
import { FEATURES } from '../constants';
import gsap from 'gsap';
import { useGSAP } from '@gsap/react';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export const Features: React.FC = () => {
  const container = useRef<HTMLElement>(null);

  useGSAP(() => {
    gsap.from('.feature-item', {
      y: 40,
      opacity: 0,
      duration: 0.8,
      stagger: 0.15,
      ease: 'power3.out',
      scrollTrigger: {
        trigger: container.current,
        start: 'top 85%',
        toggleActions: 'play none none none'
      }
    });
  }, { scope: container });

  return (
    <section ref={container} className="py-10 md:py-16 bg-white border-b border-earth-200">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-8 lg:gap-12">
          {FEATURES.map((feature, index) => (
            <div key={index} className="feature-item flex flex-col items-center text-center p-2 md:p-4">
              <div className="w-12 h-12 md:w-16 md:h-16 bg-herbal-100 rounded-full flex items-center justify-center mb-3 md:mb-6 text-herbal-800 transition-transform hover:scale-110">
                <feature.icon className="h-6 w-6 md:h-8 md:w-8" />
              </div>
              <h3 className="font-heading text-sm md:text-lg font-bold text-gray-900 mb-1 md:mb-2">
                {feature.title}
              </h3>
              <p className="text-gray-600 text-xs md:text-sm leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};